module.exports = __webpack_public_path__ + "static/media/zhuzijianshan_mobile.3bcdf875.png";